import { GridRenderCellParams } from '@mui/x-data-grid-pro';

export default (alias: (text: string) => string = (text) => text) => [
  {
    field: 'pointAlias',
    headerName: alias('Alias'),
    description: alias('Alias displayed in the UI'),
    type: 'string',
    flex: 1,
  },
  {
    field: 'deviceType',
    headerName: alias('Device Type'),
    description: alias('Device type of the point'),
    type: 'string',
    flex: 1,
  },
  {
    field: 'displayName',
    headerName: alias('Display Name'),
    description: alias('Device name of the point'),
    type: 'string',
    flex: 1,
  },
  {
    field: 'pointName',
    headerName: alias('Point Name'),
    description: alias('Name of the point'),
    type: 'string',
    flex: 1,
  },
  {
    field: 'dataType',
    headerName: alias('Data Type'),
    description: alias('Type of data the point holds'),
    type: 'string',
    flex: 1,
  },
  {
    field: 'isSiteControllerSourceDevicePointConfig',
    headerName: alias('Is Site Controller Source Device Point Config?'),
    description: alias('Type of data the point holds'),
    type: 'boolean',
    flex: 1,
  },
  {
    field: 'decimalPrecision',
    headerName: alias('Decimal Precision'),
    description: alias('Number of decimal places'),
    type: 'number',
    flex: 1,
  },
  {
    field: 'scalingFactor',
    headerName: alias('Scaling Factor'),
    description: alias('Factor to multiply the value by'),
    type: 'number',
    flex: 1,
  },
  {
    field: 'invertDisplay',
    headerName: alias('Invert Display'),
    description: alias('Inverting green/red for boolean_integer'),
    type: 'number',
    flex: 1,
  },
  {
    field: 'unitOfMeasurement',
    headerName: alias('Unit of Measurement'),
    description: alias('Not current used but will be'),
    type: 'number',
    flex: 1,
  },
  {
    field: 'displayDenominator',
    headerName: alias('Display Denominator'),
    description: alias(
      'Used to attach behind the value, ie. RacksOnline/RacksTotal',
    ),
    type: 'number',
    flex: 1,
  },
  {
    field: 'valueMappings',
    headerName: alias('Value Mappings'),
    description: alias('Custom Value Mappings'),
    type: 'string',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => {
      return JSON.stringify(params.value);
    },
  },
  {
    field: 'thresholdValues',
    headerName: alias('Threshold Values'),
    description: alias('Threshold Values for point'),
    type: 'string',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => {
      return JSON.stringify(params.value);
    },
  },
];
